import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa4c2d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "В системе логируются действия:", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "вход в систему;"),
  /*#__PURE__*/_createElementVNode("li", null, "выход из системы;"),
  /*#__PURE__*/_createElementVNode("li", null, "запуск расчета плана;"),
  /*#__PURE__*/_createElementVNode("li", null, "остановка расчета плана;"),
  /*#__PURE__*/_createElementVNode("li", null, "формирование отчета;"),
  /*#__PURE__*/_createElementVNode("li", null, "импорт пакетов, контейнеров, заказов, отгрузок в плане;"),
  /*#__PURE__*/_createElementVNode("li", null, "остановка импорта;"),
  /*#__PURE__*/_createElementVNode("li", null, "экспорт пакетов, контейнеров, заказов, отгрузок в плане;"),
  /*#__PURE__*/_createElementVNode("li", null, "остановка экспорта;")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Для добавлений действия для логирования - обращайтесь к разработчикам. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Действия пользователей",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 512))
}